import { useMemo } from 'react'


// TODO: fazer documentação
export function useMemoObject<T extends {} | { [key: string]: any }>(obj: T) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => obj, Object.values(obj))
}
